<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form :inline="true" :model="listQuery" class="fn-clear">
          <el-form-item label="学生姓名" class="fn-left">
            <el-input v-model="listQuery.sub_name" />
          </el-form-item>
          <el-form-item label="练习名称" class="fn-left">
            <el-input v-model="listQuery.train_name" />
          </el-form-item>
          <el-form-item label="选择时间" class="fn-left">
            <el-date-picker v-model="listQuery.time" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeTime" />
          </el-form-item>
          <el-form-item label="适用年级" class="fn-left">
            <Select key="10" :selected.sync="listQuery.grade_id" :data="gradeLists" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="适用科目" class="fn-left">
            <Select key="5" :selected.sync="listQuery.subject_id" :data="subjectLists" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnGetCorrectHomeworkList">查询</el-button>
          </el-form-item>
          <!-- <el-form-item label="" class="fn-left">
            <el-button type="success" @click="fnAddPakcage()">添加</el-button>
          </el-form-item> -->
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="练习时间" prop="modify_time" align="center" />
        <el-table-column label="学员信息" prop="sub_name" align="center" />
        <el-table-column label="练习名称" prop="name" align="center" />
        <el-table-column label="练习类型" prop="type_name" align="center" />
        <el-table-column label="年级" prop="grade_name" align="center" />
        <el-table-column label="科目" prop="subject_name" align="center" />
        <el-table-column label="完成率" align="center">
          <template slot-scope="{row}">
            {{ row.finish }}%
          </template>
        </el-table-column>
        <el-table-column label="正确率" align="center">
          <template slot-scope="{row}">
            {{ row.accuracy }}%
          </template>
        </el-table-column>
      </el-table></div>
    <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="listQuery.total" :page-size="listQuery.limit" @current-change="fnGetCorrectHomeworkList" />
    </div>

  </div>

</template>
<script>

import Select from '@/components/Select'
import commondata from '@/utils/commondata'
var moment = require('moment')

// import { validateRequire } from '@/utils/validate'

// import Tool from '@/assets/js/tool.js'

export default {
  name: 'TyyDoubleTestRecord',
  components: {
    Select
  },
  data() {
    return {
      lists: [],
      tableKey: 0,
      listQuery: {
        p: 1,
        limit: 20,
        sub_name: '',
        train_name: '',
        subject_id: '',
        grade_id: '',
        begin_time: '',
        end_time: '',
        total: 0,
        time: '',
        status: ''
      },
      gradeLists: commondata.GRADE_LISTS,
      subjectLists: commondata.TYY_SUBJECT_LISTS
    }
  },
  created() {
    this.listQuery.time = [moment(new Date()).subtract(1, 'months').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
    this.listQuery.begin_time = this.listQuery.time[0]
    this.listQuery.end_time = this.listQuery.time[1]
    this.fnGetCorrectHomeworkList()
  },
  methods: {
    fnGetCorrectHomeworkList: function() {
      this.$http.tyyTrainList(this.listQuery).then(res => {
        this.listQuery.total = parseInt(res.data.count)
        this.lists = res.data.list
      })
    },

    changeTime: function(val) {
      if (val != null) {
        this.listQuery.begin_time = val[0]
        this.listQuery.end_time = val[1]
      } else {
        this.listQuery.begin_time = ''
        this.listQuery.end_time = ''
        this.listQuery.time = []
      }
    }
  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
